export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "pt-BR": {
        "logout": (()=>{const fn=(ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sair"])};fn.source="Sair";return fn;})(),
        "backoffice": (()=>{const fn=(ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Acessar Backoffice"])};fn.source="Acessar Backoffice";return fn;})()
      },
      "en-US": {
        "logout": (()=>{const fn=(ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Logout"])};fn.source="Logout";return fn;})(),
        "backoffice": (()=>{const fn=(ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Access Backoffice"])};fn.source="Access Backoffice";return fn;})()
      }
    }
  })
}
